<template>
  <el-row>
    <el-col
      :xs="{span:20,offset:1}"
      :sm="{span:22,offset:1}"
      :md="{span:20,offset:2}"
      :lg="{span:16,offset:4}"
      :xl="{span:16,offset:4}"
    >
      <el-card class="box-card">
        <!-- 题目 -->
        <h3 class="head-title">
          <slot name="title"></slot>
        </h3>
        <!-- 版心 -->
        <div class="w">
          <slot name="content"></slot>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "MainBody",
  data() {
    return {};
  },
  methods: {},
  components: {}
};
</script>

<style scoped>
.box-card {
  width: 100%;
  background-color: #f9f9f9;
  min-height: 540px;
  margin: auto;
}
.box-card .head-title {
  text-align: left;
  font-size: 20px;
}
.w {
  margin: auto;
  width: 88%;
}
</style>
